import React from 'react';
import './categories.scss';
import HighLightTags from './../HighlightTags/HighlightTags';
import { Link } from 'react-router-dom';
import ImageOverlay from '../../common/ImageOverlay/ImageOverlay';
import AnalyticsService from 'AnalyticsService';

const CategoryCard = ({ category }) => {
  const categoryImageUrl = category.mobileImage;
  const {
    categoryId,
    categoryDisplayName,
    isProvisional,
    mobileBannerImage,
  } = category;
  return (
    <Link
      className="category-card"
      to={`/${category.categoryName}`}
      onClick={() => {
        // Clevertap Analytics
        const key = 'View Category';
        const payload = {
          categoryId,
          categoryDisplayName,
          isProvisional,
          mobileBannerImage,
        };
        AnalyticsService.clevertap.sendCleverTapEvent(key, payload);
      }}
    >
      <div className="category-card--image-container">
        <ImageOverlay>
          <img
            src={categoryImageUrl}
            className="category-card--image"
            alt={category.name}
          />
        </ImageOverlay>
        {((category.tags?.length > 0 &&
          category.tags.indexOf('bestseller') > -1) ||
          category.isBestseller) && <HighLightTags type="bestseller" />}
      </div>

      <div className="category-card--details">
        <div className="category-card--details--name">
          {category.categoryDisplayName}
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;
